import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export function ConfirmationBadatelnaRulesDialog({
  open,
  handleClose,
  handleConfirm,
}: {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}) {
  return (
    <Dialog open={open} onClose={handleClose} scroll="paper">
      <DialogTitle>Badatelský řád</DialogTitle>
      <DialogContent dividers={true}>
        <DialogContentText>
          <p>
            Badatelský řád Ústavu dějin a archivu Univerzity Karlovy v Praze
            vydaný na základě § 36 písm. a) zákona č. 499/2004 Sb. o
            archivnictví a spisové službě a o změně některých zákonů:
          </p>
          <br />
          <br />

          <p>Čl. 1</p>

          <p>
            <b>Obecná ustanovení</b>
          </p>

          <p>
            (1) Nahlížet do archiválií lze jen po splnění podmínek stanovených v
            zákoně a v prostorách k tomu určených (dále jen „badatelna“). Do
            prostor, v nichž jsou archiválie uloženy, nemají žadatelé o
            nahlížení (dále jen „badatel“) přístup.
          </p>
          <br />

          <p>
            (2) Badatel se při vstupu do badatelny zapíše do knihy návštěv
            badatelny, kde uvede datum návštěvy, své jméno, popřípadě jména, a
            příjmení a účel návštěvy. Do badatelny nemají přístup osoby
            znečištěné, pod vlivem alkoholu, drog anebo jiných psychotropních
            látek nebo osoby ozbrojené.
          </p>
          <br />

          <p>
            (3) V badatelně archivu badatel pravdivě vyplní badatelský list,
            který je i žádostí o nahlížení do archiválií. Badatel prokáže svou
            totožnost platným občanským průkazem, cestovním pasem nebo jiným
            obdobným průkazem totožnosti zaměstnanci pověřenému službou a
            dozorem v badatelně (dále jen „dozor v badatelně“), který
            zkontroluje správnost údajů uvedených v badatelském listu. V případě
            elektronického badatelského listu je badatelský list vyplňován
            dozorem v badatelně za plné účasti badatele, který po vytištění
            badatelského listu zkontroluje všechny údaje a badatelský list
            podepíše. Nový badatelský list badatel vyplňuje vždy pro každý
            kalendářní rok, ve kterém nahlíží do archiválií, při každé změně
            účelu nahlížení a při každé změně tématu studia.
          </p>
          <br />

          <p>
            (4) Není-li badatel schopen dozoru v badatelně prokázat svou
            totožnost platným občanským průkazem, cestovním pasem nebo jiným
            obdobným průkazem totožnosti, nahlížení do archiválií se mu odepře.
          </p>
          <br />

          <p>
            (5) Badateli se archiválie předkládají na základě jeho výslovného
            požadavku, který může archivu předběžně zaslat také prostřednictvím
            držitele poštovní licence nebo zaslat anebo oznámit prostředky
            elektronické komunikace (e-mail, fax, telefon), a to na kontaktní
            adresy archivem zveřejněné na jeho internetových stránkách. Pokud
            požadavek zaslaný v písemné podobě neobsahuje veškeré údaje
            stanovené v odstavci 6 nebo pokud je formulace požadavku na
            předložení archiválií nejasná, nepřesná nebo nekonkrétní, považuje
            se takto zaslaný požadavek za informativní a badateli na jejím
            základě mohou být připraveny pouze archiválie, u kterých není
            pochyb, že mají být předmětem nahlížení.
          </p>
          <br />

          <p>
            (6) Badatel vyplní v badatelně formulář požadavků na předložení
            archiválií pro nahlížení s uvedením svého jména, popřípadě jmen,
            příjmení, tématu studia, názvu archivního souboru, čísla kartonu,
            knihy, popřípadě inventárního čísla nebo signatury či folia, které
            žádá ke studiu, a opatří ho svým podpisem a datem zpracování.
            Formulář požadavků na předložení archiválií pro nahlížení je
            přílohou badatelského listu. Pokud badatel využil postupu pro
            vyžádání archiválií k nahlížení podle odstavce 5 a jeho požadavek
            splňoval náležitosti formuláře podle tohoto odstavce, připojí se k
            badatelskému listu archivu badatelem doručený dokument. Pokud byl
            archivu doručen neúplný nebo nepřesný požadavek, vyplní v badatelně
            formulář požadavků na předložení archiválií pro nahlížení. V
            případě, že badatel postupoval podle odstavce 5 a požaduje
            předložení dalších archiválií, než o které předběžně požádal, vyplní
            formulář požadavků na předložení archiválií pro nahlížení pouze v
            rozsahu nově požadovaných archiválií pro nahlížení.
          </p>
          <br />

          <p>
            (7) Badatel před vstupem do badatelny odloží plášť, příruční
            zavazadla a jiné obdobné věci na místě k tomu určeném. Do badatelny
            může badatel vstupovat pouze s perem, tužkou, vlastními volnými
            listy papíru bez desek a záznamovým zařízením, jako je fotoaparát,
            kamera, příruční skener nebo přenosný počítač bez pouzdra. Po
            ukončení studia předloží badatel své věci ke kontrole za účelem
            zjištění, zda neodnáší archiválie z badatelny (zejména rozevře
            přenosný počítač, skener, předloží přinesené listy papíru). Věci,
            které si badatel s sebou do badatelny přináší, předloží na vyžádání
            ke kontrole i před zahájením studia v badatelně.
          </p>
          <br />

          <p>
            (8) V badatelně je nutné zachovávat klid a respektovat studijní
            prostředí, které nesmí být narušováno hlukem, hlasitou komunikací s
            dalšími badateli, nadměrným pohybem po badatelně a obdobnými
            rušivými projevy, které neodpovídají účelu návštěvy v badatelně. V
            badatelně není dovoleno kouřit, jíst, pít a telefonovat. U
            přístrojů, které si badatel případně se souhlasem dozoru badatelny
            přináší do badatelny, vypne badatel veškeré zvukové signály.
          </p>

          <br />
          <br />
          <p>Čl. 2</p>

          <p>
            (1) Při nahlížení se badatel řídí pokyny dozoru v badatelně. Dozor v
            badatelně může na badateli požadovat, aby při pořizování výpisů a
            poznámek z některých druhů archiválií používal pouze obyčejné tužky
            střední tvrdosti. Dozor v badatelně není povinen poskytovat badateli
            pomoc při čtení textu archiválií, jeho překládání do jiných jazyků,
            podávání výkladu o historických reáliích souvisejících s
            archiváliemi apod.
          </p>
          <br />

          <p>
            (2) Při nahlížení badatel archiválie co nejvíce šetří. Archiválie
            nelze používat jako psací podložky, přímo z nich kopírovat
            průpisovým papírem, podtrhávat v nich, škrtat nebo do nich vpisovat
            nebo je používat jiným způsobem či k jinému účelu než je nahlížení.
            Fyzické poškození archiválie badatelem má za následek, že badateli
            bude s okamžitou platností ukončeno povolení nahlížet do archiválií.
          </p>
          <br />

          <p>
            (3) Badatelům se zakazuje vynášet archiválie z badatelny. Vynesení
            jakékoliv archiválie z badatelny má za následek, že badateli bude s
            okamžitou platností ukončeno povolení nahlížet do archiválií.
          </p>
          <br />

          <p>
            (4) Do archiválií vyžádaných badatelem může nahlížet současně jen
            jedna osoba, a to badatel, do jehož badatelského listu byly
            předložené archiválie zapsány. V odůvodněných případech (například
            didaktických, při exkurzích) může dozor v badatelně povolit
            nahlížení více osobám.
          </p>
          <br />

          <p>
            (5) K nahlédnutí se badateli předkládají archiválie ve lhůtě, v
            celkovém množství a v množství na jeden návštěvní den podle
            provozních podmínek a technických možností archivu s přihlédnutím k
            významu a účelu nahlížení. Předkládá se vždy jen takové množství
            archiválií, jejichž počet a stav při vracení může dozor v badatelně
            bez obtíží zkontrolovat. Lhůta přípravy archiválií pro badatele
            záleží na složitosti požadavku a na místě uložení archiválií. V
            případě objednání konkrétních signatur archiválií uložených v
            pražském depozitáři jsou archiválie připravovány zpravidla do tří
            dnů od objednání, v případě nezpracovaných archiválií a v případě
            všech archiválií uložených v depozitáři v Lešeticích může tato lhůta
            činit až měsíc. Na jeden den se zpravidla předkládá 5 kartonů
            archiválií nebo srovnatelné množství jednotlivin.
          </p>
          <br />

          <p>
            (6) Archiv nevyhradí badateli archiválie v badatelně, nezahájí-li
            badatel nahlížení do archiválií do třiceti kalendářních dnů od
            sjednaného dne pro jejich předložení nebo přeruší-li nahlížení na
            dobu delší třiceti dnů. Archiválie jsou v badatelně badateli
            vyhrazeny po dobu nezbytnou k nahlížení. Pokud badatel do
            vyhrazených archiválií nenahlíží soustavně nebo pravidelně a pokud
            vyhrazené archiválie sám nevrátí, považují se archiválie za
            vyhrazené na dobu tří měsíců od data objednání. Po uplynutí této
            doby lze v odůvodněných případech prodloužit rezervaci na další
            období, zpravidla na dobu nejdéle do konce kalendářního roku. Při
            prodloužení se přihlédne též k tomu, zda jsou další žadatelé o
            nahlížení do předmětných archiválií.
          </p>
          <br />

          <p>
            (7) Archiv umožní nahlížet do archiválií jinému badateli, než který
            si tyto archiválie vyžádal k nahlížení jako první tehdy, jestliže
            badatel, kterému jsou vyhrazeny jako prvnímu, dá k takovému
            nahlížení druhým badatelem souhlas nebo jestliže každý z těchto
            badatelů prokazatelně nahlíží do těchto archiválií za jiným účelem
            nebo studuje jiné téma. V případě, že by došlo k souběžnému
            nahlížení dvěma a více badateli, archiv umožní nahlížení do těchto
            archiválií jen tomu badateli, kterému je archiv vyhradil jako
            prvnímu. Ve sporných případech rozhoduje osoba stojící v čele
            archivu.
          </p>

          <br />
          <br />
          <p>Čl. 3</p>

          <p>
            (1) V badatelně je možné při splnění dozorem stanovených podmínek
            (například zachování klidu v badatelně), a pokud nebudou ostatní
            badatelé obtěžováni, používat vlastní reprodukční zařízení k
            pořizování reprodukcí archiválií pro osobní studijní potřebu
            badatele jen se souhlasem dozoru v badatelně. Souhlas se vyjádří
            podpisem na badatelem vyplněné písemné žádosti, jejíž vzor je
            přílohou vzorového badatelského řádu. Tím není dotčena ochrana
            případných vlastnických a autorských práv a práv souvisejících.
          </p>
          <br />

          <p>
            (2) Badatel po ukončení nahlížení do archiválií své místo v
            badatelně zanechá v řádném stavu. Výpisy, poznámky a jiné pomůcky či
            věci v badatelně nezanechává, nýbrž si je odnáší s sebou.
          </p>
          <br />

          <p>
            (3) Po každém ukončení nahlížení do archiválií je badatel povinen
            vrátit archiválie v počtu, sledu a stavu, v jakém mu byly
            předloženy. Porušení má za následek, že badateli bude s okamžitou
            platností ukončeno povolení nahlížet do archiválií.
          </p>
          <br />

          <p>
            (4) Dozor v badatelně je povinen zkontrolovat počet a stav badatelem
            vrácených archiválií a potvrdit svým podpisem jejich řádné vrácení v
            badatelském listu ještě před odchodem badatele z badatelny.
          </p>
          <br />

          <p>
            (5) Informace získané z archiválií užívá badatel jen k účelu
            uvedenému v badatelském listu. Při jejich využití ve vědeckých nebo
            jiných pracích nebo zveřejnění se uvádí alespoň název archivu a
            využitých archivních souborů, a bližší označení archiválií (citace),
            z nichž bylo čerpáno.
          </p>
          <br />

          <p>
            (6) Jestliže badatel publikoval práci, která vznikla na základě
            nahlížení do archiválií uložených v archivu, zašle příslušnému
            archivu jeden její výtisk (například editace archiválií). Jestliže
            čerpal z archiválií uložených ve více archivech, zašle publikovanou
            práci pouze archivu, z jehož archiválií čerpal nejvíce; ostatním
            archivům sdělí bibliografické údaje o publikované práci, případně
            zašle dílo elektronicky ve formátu PDF.
          </p>

          <br />
          <br />
          <p>Čl. 4</p>

          <p>
            <b>Využívání archivních pomůcek</b>
          </p>

          <p>(1) Archiv umožňuje badatelům nahlížení do archivních pomůcek.</p>
          <br />

          <p>
            (2) S archivními pomůckami předloženými k nahlížení, pokud nejsou
            úředními díly a pokud splňují znaky předmětu ochrany podle
            autorského zákona, se zachází jako s literárními díly.
          </p>

          <br />
          <br />
          <p>Čl. 5</p>

          <p>
            <b>Pořizování reprodukcí archiválií</b>
          </p>

          <p>
            Reprodukce archiválií poskytuje archiv z archiválií, které badatel
            studuje nebo potřebuje pro účely úřední nebo vlastní práce uvedené v
            badatelském listu v závislosti na případném předem uděleném souhlasu
            vlastníka archiválií nebo na ochraně případných autorských práv a
            práv souvisejících. Reprodukce archiválií se poskytují v závislosti
            na provozních podmínkách a technických možnostech archivu.
            Reprodukce archiválií, u nichž to nedovoluje jejich fyzický stav, se
            neposkytují.
          </p>

          <br />
          <br />
          <p>Čl. 6</p>

          <p>
            <b>Zapůjčování archiválií za účelem studia mimo archiv</b>
          </p>

          <p>
            (1) Zapůjčování originálů archiválií k nahlédnutí do jiného archivu,
            než jsou uloženy, povoluje osoba stojící v čele archivu výjimečně, s
            přihlédnutím ke smyslu, účelu a okolnostem jejich využívání,
            bezpečnosti převozu a zajištění ochrany archiválií v místě dočasného
            uložení a s ohledem na náklady s tím spojené. Archiválie nelze
            zasílat poštou, nýbrž se vždy za předem dohodnutých podmínek
            převážejí pověřeným zaměstnancem určeným osobou stojící v čele
            archivu, který archiválie zapůjčuje.
          </p>
          <br />

          <p>
            (2) Zapůjčování originálů archiválií mimo archiv povoluje osoba
            stojící v čele archivu výjimečně a za podmínek podle odstavce 1
            pouze vlastníkovi, případně původci archiválií, a státnímu orgánu,
            kulturně vědecké instituci pro jí pořádané výstavy nebo jiné veřejné
            prezentace, orgánu územní samosprávy a osobám, které jsou podle
            zvláštního právního předpisu oprávněny nahlížet do dokumentů, pokud
            to účel nahlédnutí z důvodu výkonu úřední funkce vyžaduje. Zapůjčení
            originálů archiválií nelze odmítnout původci archiválií, jestliže
            archiválie uložil v archivu na základě smlouvy o úschově nebo na
            základě darovací či kupní smlouvy a zapůjčení archiválií si ve
            smlouvě vymínil.
          </p>
          <br />

          <p>
            (3) Pokud archiválie uložená ve veřejném archivu není ve vlastnictví
            České republiky, právnické osoby zřízené zákonem nebo územního
            samosprávného celku, je k zapůjčení archiválie nezbytný písemný
            souhlas jejího vlastníka.
          </p>
          <br />

          <p>
            (4) Při zapůjčování archiválií je archiv povinen vystavit
            vypůjčiteli revers, obsahující
          </p>
          <br />

          <p>a) přesný soupis zapůjčovaných archiválií,</p>
          <br />

          <p>b) účel výpůjčky,</p>
          <br />

          <p>c) datum výpůjčky a lhůtu vrácení archiválií,</p>
          <br />

          <p>
            d) jméno, příjmení a adresu místa pobytu na území České republiky
            nebo adresu bydliště v cizině vypůjčitele podle průkazu totožnosti,
            pokud jde o fyzickou osobu nebo,
          </p>
          <br />

          <p>
            e) v případě právnické osoby adresu sídla vypůjčitele a jméno a
            příjmení jím pověřené osoby,
          </p>
          <br />

          <p>
            f) vlastnoruční podpis vypůjčitele nebo jím pověřené osoby, jde-li o
            fyzickou osobu; v případě pověřené osoby se současně uvede její
            jméno, popřípadě jména, příjmení a adresa místa pobytu na území
            České republiky nebo adresa bydliště v cizině podle průkazu
            totožnosti a datum předložené plné moci,
          </p>
          <br />

          <p>
            g) vlastnoruční podpis statutárního orgánu vypůjčitele nebo jím
            pověřené osoby připojený k názvu nebo obchodní firmě právnické
            osoby, který je vypůjčitelem; obsahuje-li podpisový vzor osob
            jednajících za právnickou osobu otisk razítka, připojí se k podpisu
            rovněž otisk razítka právnické osoby.
          </p>
          <br />

          <p>
            (5) Zapůjčené archiválie se zapíší v archivu do zvláštní knihy
            výpůjček a zápůjček.
          </p>
          <br />

          <p>
            (6) Jestliže vypůjčitel nevrátí zapůjčené archiválie v dohodnuté
            lhůtě, a nedohodne prodloužení lhůty, nebudou mu další požadované
            archiválie zapůjčovány až do doby vrácení zapůjčených archiválií.
          </p>

          <br />
          <br />
          <p>Čl. 7</p>

          <p>
            <b>Využívání knihovny archivu</b>
          </p>
          <br />

          <p>
            Badatel může využívat knih, časopisů a novin z knihovny archivu v
            souvislosti s jeho studijním tématem a v jeho rozsahu. Studijní
            využívání knih, časopisů a novin z knihovny archivu se řídí
            výpůjčním řádem, který vydá osoba stojící v čele archivu.
          </p>

          <br />
          <br />
          <p>Čl. 8</p>

          <p>
            <b>Exkurze do archivu</b>
          </p>

          <p>
            Při exkurzi do archivu se návštěvníci zapisují do knihy návštěv
            badatelny. Vstup do jiných prostor archivu než do badatelny archivu
            povoluje osoba stojící v čele archivu a uskutečňuje se pouze v
            doprovodu jím pověřeného zaměstnance.
          </p>

          <br />
          <br />
          <p>Čl. 9</p>

          <p>
            <b>Úhrady za služby poskytované archivy</b>
          </p>

          <p>
            Výše úhrady nákladů spojených s pořízením výpisu, opisu nebo kopie
            archiválie v analogové podobě anebo s pořízením repliky archiválie v
            digitální podobě, nákladů spojených s vyhledáním archiválií a jejich
            dalším zpracováním a nákladů spojených s pořízením rešerše z
            archiválií se řídí ceníkem služeb.
          </p>

          <br />
          <br />
          <p>Čl. 10</p>

          <p>
            <b>Závěrečná ustanovení</b>
          </p>

          <p>
            Poruší-li badatel některou ze základních povinností uložených
            badatelským řádem, může mu být další nahlížení do archiválií
            odepřeno, popřípadě udělený souhlas odvolán.
          </p>

          <br />
          <p>V Praze dne 6. února 2015</p>

          <br />
          <p>prof. PhDr. Petr Svobodný, Ph.D.</p>

          <br />
          <p>ředitel ÚDAUK</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          Souhlasím
        </Button>
      </DialogActions>
    </Dialog>
  );
}
